import { AutocompleteItem, ChipsInput } from '@prismamedia/one-components';
import { FC } from 'react';
import { useSearchEnabledTagsGetter } from './getEnabledTags.web.graphql';

interface TagsInputProps {
  value?: AutocompleteItem[];
  className?: string;
  onChange?: (items: AutocompleteItem[]) => void;
}

export const TagsInput: FC<TagsInputProps> = ({
  value,
  className,
  onChange,
}) => {
  const searchTags = useSearchEnabledTagsGetter();

  const fetchList = (search: string) =>
    searchTags({ search }).then((tags) =>
      tags.map((tag) => ({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: tag.id!,
        label: tag.title,
        secondaryLabel: tag.type,
      })),
    );

  return (
    <ChipsInput
      label="Tags"
      value={value}
      onChange={onChange}
      className={className}
      autocomplete={{ fetchList, mandatoryInput: true }}
    />
  );
};
